<script>
  import { fade } from "svelte/transition";
  import { redirect } from "../pager";
  import Alert from "../components/Alert.svelte";
  import Load from "../components/Load.svelte";

  import axios from "axios";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  $: if (settings) {
    if (settings.loggedin == true) {
      window.location.href = "./";
    }
  } else {
    settings = {
      url: "https://api.dekatan.com",
      loggedin: false,
    };
  }
  let alert = [];
  let shake = "shake";
  let user = "";
  let pass = "";

  let result = false;

  let loading = false;
  async function handleSubmit(event) {
    loading = true;
    shake = "";
    axios
      .post(settings.url + "/auth/login", {
        uname: user,
        upass: pass,
      })
      .then(function (response) {
        settings = {
          url: "https://api.dekatan.com",
          token: response.data.token,
          loggedin: true,
        };
        localStorage.setItem("t", response.data.token);

        if (settings.loggedin == true) {
          axios
            .get(settings.url + "/sipade/get/scan/0", {
              params: {
                authorization: settings.token,
              },
            })
            .then(function (response) {
              settings = {
                url: "https://api.dekatan.com",
                token: settings.token,
                loggedin: true,
                data: response.data,
              };

              session.update((n) => settings);
              loading = false;
              redirect("/");
            });
        }
      })
      .catch(function (error) {
        loading = false;
        user = "";
        pass = "";
        shake = "shake";

        alert = [
          ...alert,
          {
            title: "Dekatan",
            message: "Pastikan nomor ktp & kata sandi anda sudah tepat",
            color: "orange",
          },
        ];
      })
      .then(function () {
        loading = false;
        // always executed
        if (!sessionStorage["welcome_message"]) {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message:
                "Hallo, Selamat datang, semoga hari anda menyenangkan...",
              color: "green",
            },
          ];
        }
        sessionStorage["welcome_message"] = false;
      });
  }
</script>

<svelte:head>
  <title>Masuk Ke Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}

<main
  transition:fade
  class="container flex justify-end px-2 pt-0 mx-auto mb-2 lg:pt-0 md:pt-16"
>
  {#if loading}
    <Load />
  {/if}
  <div class="shake {shake}">
    <div class="w-full mx-auto mt-24 lg:mt-5 md:w-2/4 lg:w-4/12">
      <div class="flex justify-center font-bold">
        <img
          on:click={() => redirect("/")}
          src="./assets/logo/logo.svg"
          width="274"
          height="64"
          alt="logo"
          class="h-16 cursor-pointer"
        />
      </div>
      <h2 class="mb-4 text-center text-gray-700 text-1xl">
        Silakan <b>masuk</b> dengan akun kamu
      </h2>

      <div class="flex flex-wrap items-center w-full mx-auto my-5 lg:my-0 ">
        <div class="w-full mx-auto mb-2">
          <div class="block px-4 py-3 bg-white rounded-lg shadow-md group">
            <ul class="mt-5 list-unstyled multi-steps tablist" />
            <div id="stepcontID1" class="block stepcontID">
              <form
                autocomplete="off"
                class="w-full"
                on:submit|preventDefault={handleSubmit}
              >
                <div class="px-2 pb-2">
                  <div class="w-full mb-2">
                    <a
                      href="/"
                      on:click={() => redirect("/")}
                      class="inline-block px-2 py-1 mb-2 text-sm text-green-600 border rounded focus:outline-none"
                      >&lt; Kembali ...</a
                    >
                    <div class="flex items-center">
                      <input
                        name="user"
                        autocomplete="off"
                        bind:value={user}
                        type="text"
                        id="user"
                        placeholder="Username"
                        class="w-full px-3 py-2 text-2xl text-center text-gray-700 border rounded focus:outline-none"
                      />
                    </div>
                  </div>
                  <div class="w-full mb-2">
                    <div class="flex items-center">
                      <input
                        name="pass"
                        autocomplete="off"
                        bind:value={pass}
                        type="Password"
                        id="pass"
                        placeholder="Password"
                        class="w-full px-3 py-2 text-2xl text-center text-gray-700 border rounded focus:outline-none"
                      />
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="w-full px-5 py-2 text-gray-100 bg-green-600 rounded-lg text-1xl focus:bg-gray-500 focus:outline-none"
                  >
                    MASUK
                  </button>
                </div>
              </form>

              <div class="mt-5 separator">atau</div>
              <p class="flex items-center justify-between my-2">
                <a
                  href="/daftar"
                  class="block w-full px-5 py-2 text-xs text-center text-blue-700 focus:outline-none"
                  ><span class="text-gray-700">Belum Punya Akun ?</span>
                  <br />Daftar Baru</a
                >
                <a
                  href="/forget"
                  class="block w-full px-5 py-2 text-xs text-center text-orange-700 focus:outline-none"
                  ><span class="text-gray-700">Lupa Password ?</span>
                  <br />Pulihkan</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
<div class="flex justify-center max-w-screen-xl px-5 py-1 mx-auto items-bottom">
  <div
    class="w-full mt-4 text-sm font-light text-center text-gray-700 sm:py-2 sm:mt-0"
  >
    <div>
      <span class="ml-1 text-gray-700"
        >© 2021 Dekatan — PT. Rakit Solutions Indonesia</span
      >
    </div>
  </div>
</div>
